// Polyfill for Element.prototype.checkVisibility
if (!Element.prototype.checkVisibility) {
	Element.prototype.checkVisibility = function () {
		// Polyfill: checks if element is rendered (not display:none, not visibility:hidden, opacity > 0)
		const style = window.getComputedStyle(this);
		return style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity) > 0;
	};
}

/**
 * Add a class to the first visible section in the main content area
 */
function setFirstVisibleSection() {
	const className = 'first-visible-section';
	const sections = document.querySelectorAll('main > section');
	sections.forEach((section) => section.classList.remove(className));
	for (const section of sections) {
		if (section.checkVisibility?.()) {
			section.classList.add(className);
			break;
		}
	}
}

// Debounce utility
function debounce(fn, delay) {
	let timer = null;
	return function (...args) {
		clearTimeout(timer);
		timer = setTimeout(() => fn.apply(this, args), delay);
	};
}

// Run on DOMContentLoaded and on resize (debounced)
document.addEventListener('DOMContentLoaded', setFirstVisibleSection);
window.addEventListener('resize', debounce(setFirstVisibleSection, 100));
